// extracted by mini-css-extract-plugin
export var avatar = "Avatar-module--avatar--33193";
export var clickable = "Avatar-module--clickable--9b252";
export var clinicAvatar = "Avatar-module--clinicAvatar--8072a";
export var imageAvatar = "Avatar-module--imageAvatar--727fe";
export var large = "Avatar-module--large--4a1f6";
export var mask = "Avatar-module--mask--4f8b4";
export var patientAvatar = "Avatar-module--patientAvatar--600d7";
export var pharmacyAvatar = "Avatar-module--pharmacyAvatar--0f12c";